<template>
  <div id="videoDom">
    <video
      x5-video-player-fullscreen="true"
      x5-playsinline="true"
      playsinline="true"
      webkit-playsinline="true"
      muted
      autoplay
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
      style="width: 100%; height: 100%"
    ></video>
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-flvjs-es6";
import "videojs-flash";

export default {
  props: {
    videoUrl: {
      type: String,
      default: "",
    },
    videoType: {
      type: String,
      default: "",
    },
    poster: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      videoPlayer: null,
      show: true,
    };
  },
  created() {
    console.log("重新加载啦created");
    this.posterUrl = this.poster;
    this.show = true;
  },
  mounted() {
    console.log("重新加载啦mounted");
    console.log("videoType", this.videoType);
    this.posterUrl = this.poster;
    this.handelVideoUrl();
  },
  methods: {
    handelVideoUrl() {
      let options = {
        muted: true,
        controls: true, //进度条
        autoplay: true, //自动播放
        loop: false, //是否循环
        languages: {
          "zh-CN": require("video.js/dist/lang/zh-CN.json"),
        },
        language: "zh-CN",
        preload: "auto",
        poster: this.posterUrl,
      };

      const that = this;
      if (this.videoType == "flv") {
        //flv格式视频
        console.log("videoPlayer", this.videoType);

        options = {
          ...options,
          techOrder: ["html5", "flvjs"], // 兼容顺序
          flvjs: {
            mediaDataSource: {
              isLive: false,
              cors: true,
              withCredentials: false,
            },
          },
          sources: [{ src: this.videoUrl, type: "video/x-flv" }],
        };
      } else {
        //其他格式视频
        options = {
          ...options,
          sources: [{ src: this.videoUrl, type: "video/mp4" }],
        };
      }
      // console.log("this.videoUrl", this.videoUrl);
      // console.log("options", options);

      this.videoPlayer = videojs(
        this.$refs.videoPlayer,
        {
          ...options,
        },
        function onPlayerReady() {
          that.$nextTick(() => {
            // console.log("player ready");
            // console.log("player ready", this.videoPlayer);

            that.videoPlayer.on("error", (err) => {
              // console.log("first source load fail");

              that.videoPlayer.src({
                src: this.videoUrl,
                type: "video/x-flv",
              });

              that.videoPlayer.ready(function () {
                // console.log("player ready");
                player.load();
                player.play();
              });
            });
          });
        }
      );
    },
    createDom() {
      const newVideoElement = document.createElement("video");
      newVideoElement.id = "videoPlayer";
      newVideoElement.style.width = "100%";
      newVideoElement.style.height = "100%";
      newVideoElement.className =
        "video-js vjs-default-skin vjs-big-play-centered";
      newVideoElement.preload = "auto";
      const oldVideoElement = document.getElementById("videoDom");
      oldVideoElement.appendChild(newVideoElement);
    },
  },
  watch: {
    // videoUrl: {
    //   handler(newVal, oldVal) {
    //     if (newVal) {
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  destroyed() {
    if (this.videoPlayer) {
      this.videoPlayer.dispose();
    }
  },
};
</script>
